import { render, staticRenderFns } from "./videoBox.vue?vue&type=template&id=2ed555af&scoped=true&"
import script from "./videoBox.vue?vue&type=script&lang=ts&"
export * from "./videoBox.vue?vue&type=script&lang=ts&"
import style0 from "./videoBox.vue?vue&type=style&index=0&id=2ed555af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed555af",
  null
  
)

component.options.__file = "videoBox.vue"
export default component.exports